import { useQuery } from 'react-query'
import getProspectEmploymentsService from 'services/get-prospect-employments-service'
import ProspectType from 'types/prospect-type'

type UseGetProspectEmploymentsProps = {
  prospectId: ProspectType['id'] | undefined
}

function useGetProspectEmployments({
  prospectId,
}: UseGetProspectEmploymentsProps) {
  const shouldFetch = Boolean(prospectId)
  const { data, error, status } = useQuery(
    ['/prospects/{prospectId}/employments', prospectId],
    () => getProspectEmploymentsService({ prospectId: prospectId! }),
    {
      enabled: shouldFetch,
    }
  )

  return {
    data: data || [],
    pending: status === 'loading' || !shouldFetch,
    error,
  }
}

export default useGetProspectEmployments
